import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { AuthUser } from '../models/user.model';
import { HTTP_SERVICE, HttpInterface } from './http.interface';
import { UserAuthInterface } from './user-auth.interface';

@Injectable()
export class UserAuthService implements UserAuthInterface {
  private readonly authKey = 'lucky.draw.auth.user';
  private currentUser: AuthUser | null = null;
  private readonly permissionsSubject = new BehaviorSubject<readonly string[]>([]);
  readonly luckyDrawPermissions$ = this.permissionsSubject.asObservable();
  constructor(@Inject(HTTP_SERVICE) private readonly http: HttpInterface) {
    const user = this.authenticatedUser;
    this.permissionsSubject.next(user?.luckyDrawPermissions ?? []);
  }
  get authenticatedUser(): AuthUser | null {
    if (this.currentUser) return this.currentUser;
    const value = localStorage.getItem(this.authKey) ?? sessionStorage.getItem(this.authKey);
    return value ? this.currentUser = JSON.parse(value) as AuthUser : null;
  }
  login(userName: string, password: string): Observable<ApiResponse<AuthUser>> { return this.http.post('v1/Auth/Login', { userName, password }); }
  refreshStorePermissions(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>('v1/Auth/GetStorePermissions').pipe(tap(response => {
      if (response.status !== 200 || !response.data || !this.currentUser) return;
      this.currentUser = { ...this.currentUser, luckyDrawPermissions: response.data };
      this.persistCurrentUser();
      this.permissionsSubject.next(response.data);
    }));
  }
  setAuthenticatedUser(user: AuthUser, rememberMe: boolean): void {
    this.currentUser = user;
    (rememberMe ? localStorage : sessionStorage).setItem(this.authKey, JSON.stringify(user));
    this.permissionsSubject.next(user.luckyDrawPermissions);
  }
  clearSession(): void {
    this.currentUser = null;
    localStorage.removeItem(this.authKey);
    sessionStorage.removeItem(this.authKey);
    this.permissionsSubject.next([]);
  }
  hasPermission(permission: string): boolean { return this.permissionsSubject.value.includes(permission); }

  private persistCurrentUser(): void {
    if (!this.currentUser) return;
    const storage = localStorage.getItem(this.authKey) !== null ? localStorage : sessionStorage;
    storage.setItem(this.authKey, JSON.stringify(this.currentUser));
  }
}
